import 'core-js/stable';
window.bootstrap = require('bootstrap');
import './forms';
import './countdown';
import './dashboard';
import './design';
